import * as React from 'react';

import { subYears } from 'date-fns';

import DayPickerInput from 'react-day-picker/DayPickerInput';
import { IAge } from '../../interfaces/IRequestForm';
import MomentLocaleUtils from 'react-day-picker/moment';
import { __ } from '../../helpers/TranslationService';

export interface IDayInputPickerComponent {
    index: number;
    elementRef?: any;
    childAge: IAge;
    minAdultAge: number;
    error?: boolean;
    onChange: Function;
    departureDate: number;
}

export const DayInputPickerComponent = (props: IDayInputPickerComponent): any => {
    const { index, childAge, minAdultAge, onChange, error, elementRef, departureDate } = props;

    const datepickerProps = {
        min: subYears(new Date(departureDate * 1000), minAdultAge),
        max: new Date(),
        placeholder: __('DD.MM.YYYY', 'dreamlines'),
    };
    const [pickerDate, setPickerDate] = React.useState(new Date());
    const handleYearMonthChange = (date: Date): void => {
        setPickerDate(date);
    };

    if (elementRef?.current !== null && error) {
        elementRef.current.scrollIntoView({ behavior: 'smooth' });
    }

    return (
        <DayPickerInput
            data-testid={`request-form-date-input-${index}`}
            dayPickerProps={{
                modifiers: {
                    disabled: [
                        {
                            before: datepickerProps.min,
                            after: datepickerProps.max,
                        },
                    ],
                },
                month: pickerDate,
                onMonthChange: handleYearMonthChange,
                captionElement: () => {
                    return (
                        <YearMonthForm
                            date={pickerDate}
                            localeUtils={MomentLocaleUtils}
                            minDate={datepickerProps.min}
                            maxDate={datepickerProps.max}
                            onChange={handleYearMonthChange}
                        />
                    );
                },
            }}
            format="DD.MM.YYYY"
            inputProps={{
                readOnly: true,
                required: true,
                style: { width: '100%' },
                className: error ? 'error' : '',
            }}
            formatDate={MomentLocaleUtils.formatDate}
            parseDate={MomentLocaleUtils.parseDate}
            value={childAge.birthday}
            placeholder={datepickerProps.placeholder}
            onDayChange={(date) => onChange(index, new Date(date))}
        />
    );
};

export interface IYearMonthForm {
    date: Date;
    minDate: Date;
    maxDate: Date;
    localeUtils: any;
    onChange: Function;
}

const YearMonthForm = (props: IYearMonthForm): any => {
    const { date, minDate, maxDate, localeUtils, onChange } = props;
    const minDateYear = minDate.getFullYear();
    const maxDateYear = maxDate.getFullYear();
    let years = [];
    for (let i = minDateYear; i <= maxDateYear; i++) {
        years.push(i);
    }
    const months = localeUtils.getMonths();
    const handleChange = function handleChange(e) {
        const { year, month } = e.target.form;
        onChange(new Date(year.value, month.value));
    };
    return (
        <form className="DayPicker-Caption">
            <select name="month" onChange={handleChange} value={date.getMonth()}>
                {months.map((month, i) => (
                    <option key={month} value={i}>
                        {month}
                    </option>
                ))}
            </select>
            <select name="year" onChange={handleChange} value={date.getFullYear()}>
                {years.map((year) => (
                    <option key={year} value={year}>
                        {year}
                    </option>
                ))}
            </select>
        </form>
    );
};
